import css from '../tpl-css/style-section-grid-item-kynorelle.js';
import containerFuild from '../html-snippets/container-fuild';

const html = `
<div data-use-custom-width="true" data-custom-width="1204" class="container" data-attribute="container-content" style="--custom-width: 1204px;">
  <div class="wrap-card">
    <div data-show="false" data-attribute="title-card" class="title-card" style="display: none;"></div>
    <div class="banner-sections">
      <a data-attribute="image-banner-left-link" href="#" class="banner-left">
        <img data-attribute="image-banner-left"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e8b3b5498a7bfe7624e4.png"
          alt="" />
      </a>
      <a data-attribute="image-banner-right-link" href="#" class="banner-right">
        <img data-attribute="image-banner-right"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e8b8f933925054d2e09c.png"
          alt="" />
      </a>
    </div>
    <div data-show="true" data-attribute="wrap-slider" class="wrap-slider" style="display: block;">
      <div class="swiper">
        <div data-attribute="list-item" class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="wrap-item-slide">
              <img data-attribute="image-item-slide"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e8fde74a3617d38d831e.png"
                alt="" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="wrap-item-slide">
              <img data-attribute="image-item-slide"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9027e03d36eb6d7dd27.png"
                alt="" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="wrap-item-slide">
              <img data-attribute="image-item-slide"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e9065286e179523205b1.png"
                alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
